{
  "name": "@reslava-loom/app",
  "version": "1.27.0",
  "main": "dist/index.js",
  "types": "dist/index.d.ts",
  "scripts": {
    "build": "tsc"
  },
  "dependencies": {
    "@reslava-loom/core": "file:../core",
    "@reslava-loom/fs": "file:../fs"
  },
  "devDependencies": {
    "typescript": "^5.5.0"
  }
}
